import React from 'react'
import { Container } from 'react-bootstrap'
import Delayed from './Delayed.js';
import './WidgetTelegram.scss';
import { FormattedMessage } from 'react-intl';

export default function WidgetTelegram({data, ...props}) {
  const { title } = data
  return (
    <div className="widget-telegram">
      <Container>
        <div className="widget-telegram__header">
          <h2>
            <FormattedMessage
              id = "news_title"
              defaultMessage={title}
            />
          </h2>
        </div>
        <div className='widget-telegram__iframe-container_left'>
          <iframe id="preview" title='Минпросвещения России'
            className='widget-telegram__iframe widget-telegram__left'
            src="https://xn--r1a.website/s/minprosrf"
            loading='lazy'>
          </iframe>
          <Delayed waitBeforeShow={500}>
            <iframe id="preview1" title='Российский учитель за рубежом'
              className='widget-telegram__iframe widget-telegram__center'
              src="https://xn--r1a.website/s/proektRUZR"
              loading='lazy'>
            </iframe>
          </Delayed>
          <Delayed waitBeforeShow={1000}>
            <iframe id="preview2" title='Ассоциация школ России и Белоруссии'
              className='widget-telegram__iframe widget-telegram__right'
              src="https://xn--r1a.website/s/Associationedu"
              loading='lazy'>
            </iframe>
          </Delayed>
          {/* <iframe id="preview1" title='Российский учитель за рубежом'
              className='widget-telegram__iframe widget-telegram__center'
              src="https://t.me/s/proektRUZR"
              loading='lazy'>
            </iframe> */}
        </div>
      {/* <iframe id="telegram-post-telegram-test" src="https://t.me/proektRUZR/2396?embed=1" width="100%" height="100%" frameborder="0" style={{overflow: 'hidden', border: 'none', minWidth: '320px', height: '379px'}}></iframe>
      <iframe id="telegram-post-telegram-test" src="https://t.me/proektRUZR/2397?embed=1" width="100%" height="100%" frameborder="0" style={{overflow: 'hidden', border: 'none', minWidth: '320px', height: '379px'}}></iframe> */}
      </Container>

    </div>
  )
}



